import { lazy } from "react";

// project imports

import Loadable from "ui-component/Loadable";
import AuthGuard from "utils/route-guard/AuthGuard";
import MainLayout from "layout/MainLayout";

// login routing

const AlumniRegister = Loadable(
  lazy(() => import("views/alumniRegistration/index"))
);
const AlumniProfile = Loadable(
  lazy(() => import("views/alumniRegistration/alumniProfile/index"))
);
const EditRegistration = Loadable(
  lazy(() => import("views/alumniRegistration/EditRegistration"))
);
const EditPersonalDetails = Loadable(
  lazy(() => import("views/alumniRegistration/UpateAlumniProfile"))
);
const PendingApplication = Loadable(
  lazy(() => import("views/alumniRegistration/pendingApplication/index"))
);
const PendingPost = Loadable(
  lazy(() => import("views/application/postApporval/index"))
);
const AIApprovedPost = Loadable(
  lazy(() => import("views/application/postApporval/AIApprovedPost"))
);
const AlumniVideos = Loadable(
  lazy(() => import("views/application/alumni-videos/AlumniVideos"))
);
const PendingStarAlumni = Loadable(
  lazy(() => import("views/application/starAlumni/index"))
);
const RaisedIssues = Loadable(
  lazy(() => import("views/application/raised-issues/RaisedIssues"))
);
const PendingPostDetails = Loadable(
  lazy(() => import("views/application/postApporval/PostDetails"))
);
const PendingStarAlumniDetails = Loadable(
  lazy(() => import("views/application/starAlumni/PendingStarAlumniDetails"))
);
const AddWorkingDetails = Loadable(
  lazy(() => import("views/alumniRegistration/alumniProfile/AddNewWorkingDetails"))
);
const AddEducationDetails = Loadable(
  lazy(() => import("views/alumniRegistration/alumniProfile/EducationDetails"))
);
const UpdateCareerStatus = Loadable(
  lazy(() =>
    import("views/alumniRegistration/alumniProfile/UpdateCareerStatus")
  )
);

// ==============================|| AUTH ROUTING ||============================== //

const RegistrationRoute = {
  path: "/",
  element: (
    <AuthGuard>
      <MainLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: "/alumni/register",
      element: <AlumniRegister />,
    },
    {
      path: "/edit/:id",
      element: <EditRegistration />,
    },
    {
      path: "/edit/profile/:id",
      element: <EditPersonalDetails />,
    },
    {
      path: "/alumni/profile/:id",
      element: <AlumniProfile />,
    },
    {
      path: "/alumni/profile",
      element: <AlumniProfile />,
    },
    {
      path: "/add/workingdetails/:id",
      element: <AddWorkingDetails />,
    },
    {
      path: "/add/educationstatus/:id",
      element: <AddEducationDetails />,
    },
    {
      path: "/update/careerStatus/:id",
      element: <UpdateCareerStatus />,
    },
    {
      path: "/pending/application",
      element: <PendingApplication />,
    },
    {
      path: "/pending/post",
      element: <PendingPost />,
    },
    {
      path: "/ai/approved/post",
      element: <AIApprovedPost />,
    },
    {
      path: "/pending/alumni-videos",
      element: <AlumniVideos />,
    },
    {
      path: "/raised-issues",
      element: <RaisedIssues />,
    },
    {
      path: "/post/details/:id/:type",
      element: <PendingPostDetails />,
    },
    {
      path: "/pending/star-alumni",
      element: <PendingStarAlumni />,
    },
    {
      path: "/pending/star-alumni/details/:id",
      element: <PendingStarAlumniDetails />,
    },
  ],
};

export default RegistrationRoute;
